const extensions = ['jpg', 'png', 'jpeg', 'webp', 'avif', 'svg']

const isValidImagePath = (src?: string | null): boolean => {
  if (!src || typeof src !== 'string') return false
  return extensions.some((ext) => src.toLowerCase().includes(ext))
}

export const imgPath = (src?: string | null, type = 'thumbnail'): string => {
  const defaultPath = `${process.env.NEXT_PUBLIC_ASSETS_PATH}/default.png`

  if (!isValidImagePath(src)) {
    return defaultPath
  }

  // At this point we know src is a valid string due to isValidImagePath check
  const validSrc = src as string

  if (validSrc.includes('http')) {
    return validSrc
  }

  if (type === 'thumbnail' && !validSrc.includes('.svg')) {
    return `${process.env.NEXT_PUBLIC_ASSETS_PATH}/thumbnail/${validSrc}`
  }

  if (validSrc.includes('.svg') && !validSrc.includes('http')) {
    return `${process.env.NEXT_PUBLIC_ASSETS_PATH}/img/${validSrc}`
  }

  return `${process.env.NEXT_PUBLIC_ASSETS_PATH}/${validSrc}`
}

export const picturesFormater = (
  pictures: Array<string | null> | string | null | undefined,
  type = 'thumbnail',
): string[] => {
  try {
    // Convert input to array and filter out invalid values
    const pictureArray = Array.isArray(pictures) ? pictures : [pictures]

    return pictureArray
      .filter((pic): pic is string => typeof pic === 'string')
      .map((pic) => imgPath(pic, type))
  } catch (error) {
    console.error('Error formatting pictures:', error)
    return [imgPath(null)] // Return default image path
  }
}
